import { render } from "./seller_portal.vue?vue&type=template&id=61b10a8c"
import script from "./seller_portal.vue?vue&type=script&lang=js"
export * from "./seller_portal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__